<template>
  <v-dialog
    width="800"
    v-model="dialog"
  >
    <v-form @submit.prevent.stop="$canWrite && (submit())">
      <v-card>
        <v-card-title>
          Intervention
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" v-if="!isSubmitting">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{ intervention.project.label }}
        </v-card-subtitle>
        <!-- <v-toolbar color="primary darken-1" dark>
          <v-toolbar-title>Intervention</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false" v-if="!isSubmitting">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar> -->
        <v-card-text class="pa-5">
          <v-alert
            :value="true"
            type="error"
            class="mb-2"
            v-if="errors.length"
          >
            Veuillez corriger les erreurs suivantes :
            <ul>
              <li v-for="(error, i) in errors" :key="`error${i}`">
                {{ error }}
              </li>
            </ul>
          </v-alert>
          <v-row justify="center" align="center">
            <v-col cols="8">
              <v-menu
                v-model="isStartDateDatePickerOpened"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startDateFormatted"
                    label="Date de début*"
                    prepend-inner-icon="today"
                    readonly
                    outlined
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startDate"
                  :allowed-dates="isAllowedDate"
                  @input="isStartDateDatePickerOpened = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="nbDays" type="number" @blur="validateNbDays" min="1" label="Nombre de jours*" outlined hide-details required />
            </v-col>
          </v-row>
          <v-row justify="center" align="center">
            <v-col>
              <v-autocomplete
                :error="autocompleteAssigneeError"
                label="Assigné à"
                :items="users"
                v-model="selectedAssigneeId"
                item-value="id"
                item-text="name"
                hide-details
                clearable
                outlined
                :loading="!areUsersFetched"
                append-icon=""
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" v-if="!isSubmitting">Annuler</v-btn>
          <v-btn :disabled="!$canWrite" color="primary darken-1" :loading="isSubmitting" type="submit" depressed>Mettre à jour</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  name: `ProjectInterventionModal`,

  props: {
    intervention: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    isOpned: true,
    startDate: null,
    nbDays: 1,
    selectedAssigneeId: null,
    areUsersFetched: false,
    autocompleteAssigneeError: false,
    isStartDateDatePickerOpened: false,
    errors: [],
    isSubmitting: false,
  }),

  computed: {
    dialog: {
      get() { return this.isOpned; },
      set(isOpened) {
        this.isOpned = isOpened;
        if (!isOpened) {
          this.$emit(`close`);
        }
      },
    },
    ...mapState(`model/user`, {
      users(state) {
        return state.users.map(user => ({
          ...user,
          name: `${user.firstname} ${user.lastname}`,
        }));
      },
    }),
    startDateFormatted() { return moment(this.startDate, `YYYY-MM-DD`).format(`DD/MM/YYYY`); },
  },

  methods: {
    async fetchUsers() {
      this.areUsersFetched = false;
      this.$store.dispatch(`ui/projects/fetchUsers`);
      this.areUsersFetched = true;
    },
    newClientCreated(client) {
      this.selectedClientId = client.id;
    },
    isAllowedDate(date) {
      return !_.includes([0, 6], moment(date).day());
    },
    validateNbDays() {
      if (this.nbDays < 1) {
        this.nbDays = 1;
      }
    },
    addDaysToDate(date, nbDays) {
      const updatedDate = date.clone();
      const nbDaysAbs = Math.abs(nbDays);
      // const inc = nbDays > 0 ? 1 : -1;
      const method = nbDays > 0 ? `add` : `subtract`;
      for (let index = 0; index < nbDaysAbs; index += 1) {
        do {
          updatedDate[method](1, `days`);
        } while (!this.isAllowedDate(updatedDate));
      }

      return updatedDate;
    },
    async submit() {
      this.errors = [];
      // if (!this.label || !_.trim(this.label).length) { this.errors.push(`Le nom du chantier est obligatoire`); }
      // if (!this.selectedClientId) { this.errors.push(`Le client est obligatoire`); }

      if (this.errors.length) { return; }

      const nbDays = parseInt(this.nbDays, 10);
      const endDate = this.addDaysToDate(moment(this.startDate), nbDays - 1).format(`YYYYMMDD`);
      const startDate = moment(this.startDate).format(`YYYYMMDD`);
      // const endDate = moment(this.startDate);
      // for (let index = 0; index < nbDays; index += 1) {
      //   endDate.add(1, `days`);
      //   if (!this.isAllowedDate(endDate)) {
      //     endDate.startOf(`isoWeek`).add(1, `week`);
      //   }
      // }

      // console.log(startDate, nbDays, endDate);

      this.isSubmitting = true;
      await this.$store.dispatch(`ui/projects/updateIntervention`, {
        ...this.intervention,
        plannedStartAt: startDate,
        plannedEndAt: endDate,
        plannedDaysDuration: nbDays,
        Assignee_id: this.selectedAssigneeId,
      });
      this.isSubmitting = false;
      this.dialog = false;
      this.$emit(`submitted`);
    },
  },

  async beforeMount() {
    this.startDate = moment(this.intervention.plannedStartAt, `YYYYMMDD`).format(`YYYY-MM-DD`);
    this.nbDays = parseInt(this.intervention.plannedDaysDuration, 10);
    this.selectedAssigneeId = this.intervention.Assignee_id;
    this.fetchUsers();
  },

  components: {
  },

};
</script>

<style lang="scss">
</style>
